var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1140",
    "data-name": "Grupo 1140",
    transform: "translate(-256 -788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_129",
    "data-name": "Elipse 129",
    transform: "translate(256 788)",
    fill: "none",
    stroke: "#ccff1c",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 24.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_690",
    "data-name": "Caminho 690",
    d: "M5664.068,812.864l8.517,8.454c-.756,1.3,11.135-16.958,11.135-16.958",
    transform: "translate(-5392)",
    fill: "none",
    stroke: "#ccff1c",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.997bb3799e8ec32dfb412bfccbdbc4fa.svg";
export { ForwardRef as ReactComponent };